module.exports = __webpack_public_path__ + "img/gzlb- 4.8da97d16.jpg";